import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { MaquinaEquipDropdown } from "../../../../domain/models/maquina_equip_dropdown";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { ControleInspecaoMaquinaForm, ControleInspecaoMaquinaSchema } from "../../../schemas/MaquinasEquipItens_controle/MaquinasEquipItens_controle";
import { DefaultFormDatePickerInput } from "../../../../../../common/components/default_form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { InspecaoMaquinaEquipLista } from "../../../../domain/models/inspecao_maquina_equip_lista";


/**
 * ModalCreateMaquinasequipControle
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedInspecaoMaquinaEquip: InspecaoMaquinaEquipLista | null;
  maquinaEquipDropDown: MaquinaEquipDropdown[];
  onClose: () => void;
  onSubmit: (form: ControleInspecaoMaquinaForm) => void;
};

export const ModalCreateMaquinasequipControle = ({
  open,
  saving,
  loading,
  selectedInspecaoMaquinaEquip,
  maquinaEquipDropDown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ControleInspecaoMaquinaForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ControleInspecaoMaquinaSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedInspecaoMaquinaEquip) {
        hookForm.setValue("dataInspecao", selectedInspecaoMaquinaEquip.dataInspecao ? selectedInspecaoMaquinaEquip.dataInspecao : null);
        hookForm.setValue("idMaquinaEquip", selectedInspecaoMaquinaEquip.idMaquinaEquip ?? 0);
        hookForm.setValue("codigoMaquinaEquip", selectedInspecaoMaquinaEquip.codigoMaquinaEquipamento ?? "");
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedInspecaoMaquinaEquip,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Inspeção"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 my-2">
        <DefaultFormDatePickerInput
          name='dataInspecao'
          label='Data de Abertura'
          reactHookForm={hookForm}
        />

        <DefaultFormAutocomplete
          name='idMaquinaEquip'
          label='Máquina/Equipamento'
          required={true}
          readOnly={selectedInspecaoMaquinaEquip !== null}
          getOptionKey={x => x.idMaquinaEquip}
          getOptionLabel={x => x.descricao}
          options={maquinaEquipDropDown}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='codigoMaquinaEquip'
          label='Código da Máquina/Equipamento'
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
};
